import { render, staticRenderFns } from "./comip.vue?vue&type=template&id=6aa8bd6e&lang=pug"
import script from "./comip.vue?vue&type=script&lang=js"
export * from "./comip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports